import React from 'react'
import { fnum } from '../../utils/utils'

export default class SmetaSubTotalItem extends React.Component {
  
  render() {    

    const { data } = this.props;
     
    if(data.hasOwnProperty('post_desc')){
      return (
        <tr>
          <td></td>
          <td>{data.post_desc}</td>
          <td></td>
          <td></td>
          <td className='text-right'>{fnum(data.post_price*data.post_qntt)}</td>
        </tr>
      )
    }
    else{
      return (
        null
      )
    }
    
  }
}


// WEBPACK FOOTER //
// ./src/components/smeta/SmetaSubTotalItem.js